import { gql } from '@common/hooks';
import { RATE_FIELDS } from '@scheduling/services';

const RATE_FIELDS_FOR_QUERY = RATE_FIELDS.flatMap((field) => `${field}\n`);

export const OnDemandRateFields = gql`
  fragment OnDemandRateFields on WorkforceGroupUnitRate {
    type
    ${RATE_FIELDS_FOR_QUERY}
    priceRange
    incentiveIncrement
    effectiveDate
    endDate
    createdAt
    updatedAt
    workforceGroup {
      id
      name
    }
    organizationUnit {
      id
      name
    }
    createdBy {
      id
      name
    }
  }
`;
